<template>
  <main 
    :class="mode" 
    class="flex-col flex content-center justify-evenly flex-auto w-full
     relative items-center"
  >
    <header
      v-if="hasTitle" 
      class=" flex-col flex w-screen h-82 items-center justify-center self-center
      relative bg-no-repeat bg-center bg-cover " 
      :style="backgroundURL"
    >
      <h2 class="relative z-50 text-red-200 text-4xl">
        {{ title }}
      </h2>
    </header>
    <div 
      class="mainBody flex-col flex content-center justify-evenly flex-auto 
      overflow-y-visible overflow-x-visible 
      w-full max-full md:max-w-screen-md items-center"
    >
      <slot></slot>
    </div>    
  </main>
</template>

<script>

export default {
  props: {
      mode: {
        type: String,
        required: false,
        default: ''
      }, 
      url: {
        type: String,
        required: false,
        default: ''
      }, 
      title: {
        type: String,
        required: false,
        default: ''
      },  
  },
  computed: {
    backgroundURL() {
      const styleURL = 'background-image: url(' + this.url + ')'
      return styleURL
    },
    hasTitle(){
      if (this.title == ''|| this.title == null){
        return false
      }
      return true
    },
  },
  created(){
    
  }
}
</script>
